export const variantConfig = {
  primary: 'bg-primary text-on-primary',
  primaryGlass:
    'before:bg-linear-to-b before:-rotate-45 before:scale-150 before:absolute before:w-full before:aspect-square before:transition-all before:from-magenta hover:before:rotate-0 before:to-primary text-on-primary shadow-lg',
  primaryContainer: 'bg-primary-container text-on-primary-container',
  primaryOutline: 'text-primary ring-1 ring-inset ring-primary',
  info: 'bg-info text-on-info',
  infoOutline: 'text-info ring-1 ring-inset ring-info',
  success: 'bg-success text-on-success',
  successOutline: 'text-success ring-1 ring-inset ring-success',
  warning: 'bg-warning text-on-warning',
  warningOutline: 'text-warning ring-1 ring-inset ring-warning',
  error: 'bg-error text-on-error',
  errorOutline: 'text-error ring-1 ring-inset ring-error',
  outline:
    'text-on-surface ring-1 ring-inset ring-outline-variant hover:ring-outline',
  container: 'bg-surface-container text-onSurface'
}

export const sizeConfig = {
  lg: 'py-4 px-4 has-[>span]:px-8',
  default: 'py-3 px-3 has-[>span]:px-5',
  xs: 'py-1 px-1 has-[>span]:px-2',
  sm: 'py-2 px-2 has-[>span]:px-4'
}

export const iconSizeConfig = {
  default: '20px',
  xs: '12px',
  sm: '16px',
  lg: '24px',
  xl: '26px'
}
